import { lazy, Suspense, useEffect } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import routes from "./config";
import { Styles } from "../styles/styles";
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase";

const Router = () => {

  const location = useLocation();

  useEffect(() => {
    if (analytics) {
      logEvent(analytics, "page_view", {
        page_location: window.location.href,
        page_path: location.pathname,
      });
    }
  }, [location]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <Suspense fallback={null}>
      <Styles />
      <Header />
      <main id="main-content">
        <Switch>
          {routes.map((routeItem) => {
            return (
              <Route
                key={`${routeItem.component}-${routeItem.path}`}
                path={routeItem.path}
                exact={routeItem.exact}
                component={lazy(() => import(`../pages/${routeItem.component}`))}
              />
            );
          })}
        </Switch>
      </main>
      <Footer />
    </Suspense>
  );
};

export default Router;
